document.addEventListener('DOMContentLoaded', function () {
    const reviewSliders = document.querySelectorAll('.product_review-slider');

    reviewSliders.forEach(function (slider) {
        if (slider.swiper) {
            slider.swiper.destroy(true, true);
        }

        new Swiper(slider, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 10,
            loop: true,
            speed: 500,

            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true
            }
        });
    });
});

// Infinity Scroll

(() => {
  const initMobileLogoMarquee = () => {
    document.querySelectorAll('.mobile-logo-list').forEach((container) => {
      const list = container.querySelector('.logo-list_grid');

      if (!list || list.dataset.marqueeInit === 'true') return;

      const originalItems = Array.from(list.children);

      if (!originalItems.length) return;

      list.dataset.marqueeInit = 'true';

      for (let cloneIndex = 0; cloneIndex < 3; cloneIndex++) {
        originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          list.appendChild(clone);
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileLogoMarquee);
  } else {
    initMobileLogoMarquee();
  }

  document.addEventListener(
    'shopify:section:load',
    initMobileLogoMarquee
  );
})();

// Product Main media Swiper

class GHSWiperSlider extends HTMLElement {
    constructor() {
        super();
        this.mainSlider = null;
        this.thumbnailSlider = null;
    }

    connectedCallback() {
        if (typeof Swiper === 'undefined') {
            console.warn('Swiper is not loaded yet.');
            return;
        }
        this.init();
    }

    init() {
        const mainSlider = this.querySelector('[data-main-slider]');
        const thumbnailSlider = this.querySelector('[data-thumbnail-slider]');

        if (!mainSlider || !thumbnailSlider) return;

        if (mainSlider.swiper) {
            mainSlider.swiper.destroy(true, true);
        }

        if (thumbnailSlider.swiper) {
            thumbnailSlider.swiper.destroy(true, true);
        }

        this.thumbnailSlider = new Swiper(thumbnailSlider, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            freeMode: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            speed: 300
        });


        this.mainSlider = new Swiper(mainSlider, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 12,
            speed: 400,
            grabCursor: true,
            thumbs: {
                swiper: this.thumbnailSlider
            }
        });
    }

    disconnectedCallback() {
        if (this.mainSlider) {
            this.mainSlider.destroy(true, true);
            this.mainSlider = null;
        }

        if (this.thumbnailSlider) {
            this.thumbnailSlider.destroy(true, true);
            this.thumbnailSlider = null;
        }
    }
}


if (!customElements.get('gh-swiper-slider')) {
    customElements.define('gh-swiper-slider', GHSWiperSlider);
}

// Product Bundle JS

(() => {
  class ProductVariantController {
    constructor(variantPicker) {
      this.variantPicker = variantPicker;
      this.variantButtons = variantPicker.querySelectorAll('.option__value');
      this.variantDataElement = variantPicker.querySelector('[data-product-variants]');

      this.variants = [];
      this.selectedOptions = [];
      this.currentVariant = null;

      this.productForm = null;
      this.variantInput = null;
      this.submitButton = null;
      this.buttonText = null;
      this.buttonPrice = null;

      this.init();
    }

    init() {
      if (!this.variantDataElement) {
        console.warn('Variant data not found', this.variantPicker);
        return;
      }

      try {
        this.variants = JSON.parse(this.variantDataElement.textContent);
      } catch (error) {
        console.error('Unable to parse product variants', error);
        return;
      }

      this.findProductForm();
      this.bindVariantButtons();
      this.setInitialOptions();
      this.updateVariant();
    }

    findProductForm() {
      const productSection = this.variantPicker.closest('.redesign-main-product');

      if (productSection) {
        this.productForm = productSection.querySelector('product-form');
      }

      if (!this.productForm) {
        this.productForm = document.querySelector('product-form');
      }

      if (!this.productForm) {
        console.warn('Product form not found');
        return;
      }

      this.variantInput = this.productForm.querySelector('.js-variant-id');
      this.submitButton = this.productForm.querySelector('.js-productForm-submit');
      this.buttonText = this.submitButton?.querySelector('.btn-text');
      this.buttonPrice = this.submitButton?.querySelector('.js-atc-price');
    }

    bindVariantButtons() {
      this.variantButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const optionName = button.dataset.optionName;
          const optionValue = button.dataset.optionValue;

          if (!optionName || !optionValue) {
            return;
          }

          const optionPosition = this.getOptionPosition(optionName);
          this.selectedOptions[optionPosition] = optionValue;

          this.updateOptionUI(button);
          this.updateVariant();
        });
      });
    }

    getOptionPosition(optionName) {
      const option = this.variantPicker.querySelector(
        `.product-option.option-${this.handleize(optionName)}`
      );

      if (!option) {
        return 0;
      }

      const options = this.variantPicker.querySelectorAll('.product-option');
      return Array.from(options).indexOf(option);
    }

    setInitialOptions() {
      const options = this.variantPicker.querySelectorAll('.product-option');

      options.forEach((option, index) => {
        const activeButton = option.querySelector('.option__value.is-active');

        if (activeButton) {
          this.selectedOptions[index] = activeButton.dataset.optionValue;
        }
      });
    }

    updateOptionUI(clickedButton) {
      const optionWrapper = clickedButton.closest('.product-option');

      if (!optionWrapper) {
        return;
      }

      optionWrapper.querySelectorAll('.option__value').forEach((button) => {
        button.classList.remove('is-active');
      });

      clickedButton.classList.add('is-active');
    }

    updateVariant() {
      if (!this.variants.length) {
        return;
      }

      const variant = this.variants.find((variant) => {
        return variant.options.every((optionValue, index) => {
          return optionValue === this.selectedOptions[index];
        });
      });

      this.currentVariant = variant || null;

      //console.log('Selected Variant:', this.currentVariant);

      if (!this.currentVariant) {
        this.handleUnavailableCombination();
        return;
      }

      this.updateForm();
      this.updateButton();
      this.updateURL();
      this.dispatchVariantChange();
    }

    selectVariant(variant) {
        if (!variant || !variant.options) {
            return;
        }

        const options = this.variantPicker.querySelectorAll('.product-option');

        variant.options.forEach((optionValue, index) => {
            this.selectedOptions[index] = optionValue;

            const optionWrapper = options[index];

            if (!optionWrapper) {
            return;
            }

            optionWrapper
            .querySelectorAll('.option__value')
            .forEach((button) => {
                button.classList.toggle(
                'is-active',
                button.dataset.optionValue === optionValue
                );
            });
        });

        this.updateVariant();
    }

    updateForm() {
      if (!this.variantInput) {
        return;
      }

      this.variantInput.value = this.currentVariant.id;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateButton() {
      if (!this.submitButton) {
        return;
      }

      const variant = this.currentVariant;

      if (variant.available) {
        this.submitButton.disabled = false;

        if (this.buttonText) {
          this.buttonText.textContent = 'Add to cart';
        }

        if (this.buttonPrice) {
          this.buttonPrice.textContent = ' — ' + this.formatMoney(variant.price);
        }
      } else {
        this.submitButton.disabled = true;

        if (this.buttonText) {
          this.buttonText.textContent = 'Sold out';
        }

        if (this.buttonPrice) {
          this.buttonPrice.textContent = '';
        }
      }
    }

    handleUnavailableCombination() {
      if (!this.submitButton) {
        return;
      }

      this.submitButton.disabled = true;

      if (this.buttonText) {
        this.buttonText.textContent = 'Unavailable';
      }

      if (this.buttonPrice) {
        this.buttonPrice.textContent = '';
      }
    }

    updateURL() {
      if (!this.currentVariant || !window.history || !window.history.replaceState) {
        return;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', this.currentVariant.id);
      window.history.replaceState({}, '', url.toString());
    }

    dispatchVariantChange() {
      document.dispatchEvent(
        new CustomEvent('product:variant-change', {
          detail: {
            variant: this.currentVariant,
            picker: this.variantPicker,
          },
        })
      );
    }

    formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        const moneyFormat = window.moneyFormat || Shopify.money_format || '${{amount}}';
        return Shopify.formatMoney(cents, moneyFormat);
      }

      return '$' + (cents / 100).toFixed(2);
    }

    handleize(value) {
      return value
        .toString()
        .toLowerCase()
        .trim()
        .replace(/['"]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }
  }

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') {
        return;
      }

      this.dataset.initialized = 'true';
      this.controller = new ProductVariantController(this);
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }
})();

(() => {
    const getProductForm = () =>
        document.querySelector(
            '.productForm[data-type="add-to-cart-form"], .productForm, form[data-product-form]'
        );

    const getSelectedProducts = () =>
        [...document.querySelectorAll('[data-bundle-product].is-selected')];

    const removeBundleInputs = (form) => {
        form
            .querySelectorAll('[data-bundle-hidden-input]')
            .forEach((input) => input.remove());
    };

    const syncBundleInputs = (form) => {
        if (!form) return;

        removeBundleInputs(form);

        const selectedProducts = getSelectedProducts();

        selectedProducts.forEach((product, index) => {
            const variantId = product.dataset.variantId;

            if (!variantId) return;

            const idInput = document.createElement('input');

            idInput.type = 'hidden';
            idInput.name = `items[${index}][id]`;
            idInput.value = variantId;
            idInput.setAttribute(
                'data-bundle-hidden-input',
                ''
            );

            form.appendChild(idInput);

            const quantityInput = document.createElement('input');

            quantityInput.type = 'hidden';
            quantityInput.name = `items[${index}][quantity]`;
            quantityInput.value = '1';
            quantityInput.setAttribute(
                'data-bundle-hidden-input',
                ''
            );

            form.appendChild(quantityInput);
        });
    };

    const updateProductVariant = (product, variantId) => {
        if (!variantId) return;

        product.dataset.variantId = variantId;

        const form = getProductForm();

        if (!form) return;

        if (product.classList.contains('is-selected')) {
            syncBundleInputs(form);
        }
    };

    const initBundleUpsells = () => {
        const bundleProducts =
            document.querySelectorAll('[data-bundle-product]');

        if (!bundleProducts.length) return;

        const form = getProductForm();

        bundleProducts.forEach((product) => {
            if (product.dataset.bundleInit) return;

            product.dataset.bundleInit = 'true';

            const toggle =
                product.querySelector('[data-bundle-toggle]');

            const variantSelect =
                product.querySelector('[data-bundle-variant-select]');

            if (variantSelect) {
                variantSelect.addEventListener('change', (event) => {
                    updateProductVariant(
                        product,
                        event.target.value
                    );
                });
            }

            if (!toggle) return;

            toggle.addEventListener('click', () => {
                const isActive =
                    product.classList.toggle('is-selected');

                toggle.classList.toggle(
                    'is-active',
                    isActive
                );

                toggle.setAttribute(
                    'aria-pressed',
                    isActive ? 'true' : 'false'
                );

                const currentForm = getProductForm();

                if (!currentForm) return;

                syncBundleInputs(currentForm);
            });

            if (toggle.classList.contains('is-active')) {
                product.classList.add('is-selected');
            }
        });

        if (form) {
            syncBundleInputs(form);
        }
    };

    const init = () => {
        initBundleUpsells();
    };

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            init
        );
    } else {
        init();
    }

    document.addEventListener(
        'shopify:section:load',
        init
    );
})();

(() => {
    const productData = document.querySelector(
        '[data-product-variants]'
    );

    const stickyAtc = document.querySelector(
        '[data-sticky-atc]'
    );

    if (!productData || !stickyAtc) return;

    const variants = JSON.parse(
        productData.textContent
    );

    const stickySelect = stickyAtc.querySelector(
        '[data-sticky-variant-select]'
    );

    const stickyPrice = stickyAtc.querySelector(
        '[data-sticky-price]'
    );

    const stickyButton = stickyAtc.querySelector(
        '[data-sticky-atc-button]'
    );

    const stickyImage = stickyAtc.querySelector(
        '.sticky-product-atc__image-img'
    );

    const productForm = document.querySelector(
        '.productForm[data-type="add-to-cart-form"], .productForm'
    );

    const moneyFormat = (cents) => {
        if (
            window.Shopify &&
            typeof Shopify.formatMoney === 'function'
        ) {
            return Shopify.formatMoney(
                cents,
                Shopify.money_format
            ).replace(/\.00$/, '');
        }

        return (cents / 100).toFixed(2);
    };

    const getVariant = (variantId) => {
        return variants.find(
            (variant) =>
                String(variant.id) === String(variantId)
        );
    };

    const updateSticky = (variant) => {
        if (!variant) return;

        stickySelect.value = String(variant.id);

        if (stickyPrice) {
            stickyPrice.textContent =
                moneyFormat(variant.price);
        }

        if (stickyButton) {
            stickyButton.disabled = !variant.available;

            const buttonText =
                stickyButton.querySelector(
                    '[data-sticky-atc-text]'
                );

            if (buttonText) {
                buttonText.textContent =
                    variant.available
                        ? 'Add To Cart'
                        : 'Sold Out';
            }
        }

        if (
            stickyImage &&
            variant.featured_image &&
            variant.featured_image.src
        ) {
            stickyImage.src =
                variant.featured_image.src;
        }
    };

    const selectMainVariant = (variant) => {
        if (!variant || !variant.options) return;

        const picker = document.querySelector(
            'variant-picker'
        );

        if (!picker) return;

        variant.options.forEach(
            (optionValue, index) => {
                const optionName =
                    picker.querySelectorAll(
                        '.product-option'
                    )[index]
                    ?.querySelector(
                        '[data-option-name]'
                    )
                    ?.dataset.optionName;

                if (!optionName) return;

                const button = [
                    ...picker.querySelectorAll(
                        '.product-option__value'
                    )
                ].find(
                    (item) =>
                        item.dataset.optionName ===
                            optionName &&
                        item.dataset.optionValue ===
                            optionValue
                );

                if (button) {
                    button.click();
                }
            }
        );
    };

    stickySelect.addEventListener('change', (event) => {
        const variant = getVariant(event.target.value);

        if (!variant) {
            return;
        }

        const picker = document.querySelector('variant-picker');

        if (
            picker &&
            picker.controller &&
            typeof picker.controller.selectVariant === 'function'
        ) {
            picker.controller.selectVariant(variant);
        }
    });

    document.addEventListener(
        'product:variant-change',
        (event) => {
            const variant = event.detail?.variant;

            if (!variant) return;

            updateSticky(variant);
        }
    );

    stickyButton.addEventListener(
        'click',
        () => {
            if (!productForm) return;

            const submitButton =
                productForm.querySelector(
                    '[type="submit"]'
                );

            if (submitButton) {
                submitButton.click();
            }
        }
    );

    const initialVariant =
        variants.find(
            (variant) =>
                variant.id ===
                Number(stickySelect.value)
        ) || variants[0];

    updateSticky(initialVariant);
})();

(() => {
  const formatMoney = (cents) => {
    if (
      typeof Shopify !== 'undefined' &&
      typeof Shopify.formatMoney === 'function'
    ) {
      const moneyFormat =
        window.moneyFormat ||
        Shopify.money_format ||
        '${{amount}}';

      return Shopify.formatMoney(
        cents,
        moneyFormat
      );
    }

    return '$' + (cents / 100).toFixed(2);
  };

  const getMainVariantPrice = () => {
    const variantInput = document.querySelector(
      '.productForm[data-type="add-to-cart-form"] .js-variant-id, .productForm .js-variant-id'
    );

    if (!variantInput?.value) return 0;

    const variantPicker =
      document.querySelector('variant-picker');

    if (!variantPicker) return 0;

    const variantsElement =
      variantPicker.querySelector(
        '[data-product-variants]'
      );

    if (!variantsElement) return 0;

    try {
      const variants = JSON.parse(
        variantsElement.textContent
      );

      const variant = variants.find(
        (item) =>
          String(item.id) ===
          String(variantInput.value)
      );

      return variant
        ? variant.price / 100
        : 0;
    } catch (error) {
      return 0;
    }
  };

  const getBundleTotal = () => {
    let total = 0;

    document
      .querySelectorAll(
        '[data-bundle-product].is-selected'
      )
      .forEach((product) => {
        const price = Number(
          product.dataset.variantPrice || 0
        );

        total += price / 100;
      });

    return total;
  };

  const getCurrencyRate = () => {
    if (
      typeof Shopify !== 'undefined' &&
      Shopify.currency &&
      Shopify.currency.rate
    ) {
      return Number(Shopify.currency.rate) || 1;
    }
    return 1;
  };

  const updateFreeShipping = () => {
    const currencyRate = getCurrencyRate();

    document
      .querySelectorAll('[data-free-shipping]')
      .forEach((shippingBlock) => {
        const rawThreshold = Number(
          shippingBlock.dataset.threshold || 0
        );

        if (!rawThreshold) return;

        const threshold = rawThreshold * currencyRate;

        const shippingText =
          shippingBlock.dataset.shippingText || '';

        const qualifyText =
          shippingBlock.dataset.qualifyText || '';

        const mainVariantPrice =
          getMainVariantPrice();

        const bundleTotal =
          getBundleTotal();

        const total =
          mainVariantPrice + bundleTotal;

        const remaining =
          Math.max(
            threshold - total,
            0
          );

        const percentage =
          Math.min(
            (total / threshold) * 100,
            100
          );

        const fill =
          shippingBlock.querySelector(
            '.shipping-fill'
          );

        const text =
          shippingBlock.querySelector(
            '.shipping-text'
          );

        if (fill) {
          fill.style.width =
            `${percentage}%`;
        }

        if (!text) return;

        if (remaining > 0) {
          const formattedPrice =
            formatMoney(
              remaining * 100
            );

          text.innerHTML =
            shippingText.replace(
              '[price]',
              formattedPrice
            );
        } else {
          text.innerHTML =
            qualifyText;
        }
      });
  };

  const initFreeShipping = () => {
    updateFreeShipping();
  };

  document.addEventListener(
    'product:variant-change',
    updateFreeShipping
  );

  document.addEventListener(
    'change',
    (event) => {
      if (
        event.target.matches(
          '[data-bundle-variant-select]'
        )
      ) {
        updateFreeShipping();
      }
    }
  );

  document.addEventListener(
    'click',
    (event) => {
      if (
        event.target.closest(
          '[data-bundle-toggle]'
        )
      ) {
        setTimeout(
          updateFreeShipping,
          0
        );
      }
    }
  );

  document.addEventListener(
    'currency:change',
    updateFreeShipping
  );

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initFreeShipping
    );
  } else {
    initFreeShipping();
  }

  document.addEventListener(
    'shopify:section:load',
    initFreeShipping
  );
})();

